import { render, staticRenderFns } from "./Investor.vue?vue&type=template&id=5e09496b&scoped=true"
import script from "./Investor.vue?vue&type=script&lang=js"
export * from "./Investor.vue?vue&type=script&lang=js"
import style0 from "./Investor.vue?vue&type=style&index=0&id=5e09496b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09496b",
  null
  
)

export default component.exports